import styled from '@emotion/styled';
import {Button, Chip, Dropdown} from '@bosch/react-frok';

export const ContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
`;

export const DialogEditActionsWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
`;

export const LocalesSelectionWrapper = styled.div`
    display: grid;
    grid-template-columns: 400px;
`;
export const DropdownInput = styled(Dropdown)`
    justify-content: center;
    align-self: center;
    align-items: stretch;
    max-width: 65%;
    flex-grow: 2;
`;

export const AddButton = styled(Button)`
    margin-left: 0rem;
    margin-right: 1rem;
    margin-top:1.5rem ;
    min-width: 120px;
`;

export const ResetButton = styled(Button)`
    margin-left: 0rem;
    margin-right: 1rem;
    margin-top:1.5rem ;
    min-width: 120px;
`;

export const FolderParentName = styled.span`
    font-size: small;
    font-weight: bold;
`;

export const LocalesOnFolder = styled.span`
    font-size: small;
`;

export const ParentLocalesWrapper = styled.div`
    display: block;
`;

export const StyledChipClickableArea = styled(Chip)`
    .a-chip__close {
        width: 1.4rem;
        height: 1.4rem;
        right: 0.3rem;

        &::before,
        &::after {
            top: 0.25rem;
            right: 0.65rem;
        }
    }
`;

export const Locales = styled(StyledChipClickableArea)`
    margin-top: 0.5rem;
`;

export const LocalesLabelWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    margin-top:1.3rem ;
`;
